import axios from 'axios'

const Accounts = {
  async getRoles (params = {}) {
    return axios.get('shared/list/roles', { params })
  },

  async getFSOfficers (params = {}) {
    return axios.get('shared/list/field-officers', { params })
  },

  async getASManagers (params = {}) {
    return axios.get('shared/list/area-managers', { params })
  },

  async getCustomers (params = {}) {
    return axios.get('shared/list/customers', { params })
  },

  async getLeads (params = {}) {
    return axios.get('shared/list/leads', { params })
  }
}

const Maintenances = {
  async getActivities (params = {}) {
    return axios.get('shared/list/activities', { params })
  },

  async getAreaManagerActivities (params = {}) {
    return axios.get('shared/list/area-managers-activities', { params })
  },

  async getOfficerActivities (params = {}) {
    return axios.get('shared/list/officer-activities', { params })
  },

  async getTradingTerms (params = {}) {
    return axios.get('shared/list/trading-terms', { params })
  },

  async getDocumentTypes (params = {}) {
    return axios.get('shared/list/document-types', { params })
  },

  async getCropCategories (params = {}) {
    return axios.get('shared/list/crop-categories', { params })
  },

  async getCrops (params = {}) {
    return axios.get('shared/list/crops', { params })
  },

  async getCropOptions (params = {}) {
    return axios.get('shared/list/crop-options', { params })
  },

  async getProductGroups (params = {}) {
    return axios.get('shared/list/product-groups', { params })
  },

  async getProductCategories (params = {}) {
    return axios.get('shared/list/product-categories', { params })
  },

  async getProducts (params = {}) {
    return axios.get('shared/list/products', { params })
  },

  async getFarms (params = {}) {
    return axios.get('shared/list/customer-farms', { params })
  },

  async getCustomerCrops (params = {}) {
    return axios.get('shared/list/customer-crops', { params })
  },

  async getPrograms (params = {}) {
    return axios.get('shared/list/programs', { params })
  },

  async getOpenMemos (params = {}) {
    return axios.get('shared/list/open-memos', { params })
  },

  async getMemos (params = {}) {
    return axios.get('shared/list/memos', { params })
  }
}

const Locations = {
  async getTeams (params = {}) {
    return axios.get('shared/list/teams', { params })
  },

  async getAreas (params = {}) {
    return axios.get('shared/list/areas', { params })
  },

  async getClusters (params = {}) {
    return axios.get('shared/list/clusters', { params })
  },

  async getRegions (params = {}) {
    return axios.get('shared/list/regions', { params })
  },

  async getProvinces (params = {}) {
    return axios.get('shared/list/provinces', { params })
  },

  async getMunicipalities (params = {}) {
    return axios.get('shared/list/municipalities', { params })
  },

  async getBarangays (params = {}) {
    return axios.get('shared/list/barangays', { params })
  }
}

const ListService = {
  async getSystemOptions (params = {}) {
    return axios.get('shared/list/system-options', { params })
  }
}

export default Object.assign(
  ListService,
  Accounts,
  Maintenances,
  Locations
)
